import { useTranslation } from "react-i18next";
import { Icon } from "semantic-ui-react";

import { DATE_FORMATS_FNS } from "components/DatePicker";
import { formatDate } from "utils/dateHelperFunctions";

type ReplacementCarNoteProps = {
  note: string;
  timestamp?: string;
  pickupTime?: string;
  dropOffTime?: string;
  licensePlate?: string;
};

export const ReplacementCarNote = ({ note, timestamp, licensePlate, pickupTime, dropOffTime }: ReplacementCarNoteProps) => {
  const { t } = useTranslation();

  return (
    <div className="dms-note-row CarReplacement">
      <div className="CarReplacement__leftWrapper">
        <div className="CarReplacement__iconContainer">
          <Icon className="car side" />
        </div>
        {licensePlate && <span className="CarReplacement__licensePlate">{licensePlate}</span>}
      </div>
      <div className="dms-note-type">
        <span>{note}</span>
        {pickupTime && <span className="CarReplacement__pickupTime">{formatDate(pickupTime, DATE_FORMATS_FNS.dateMonthYearTime)}</span>}
        {dropOffTime && (
          <span>
            {" > "}
            {formatDate(dropOffTime, DATE_FORMATS_FNS.dateMonthYearTime)}
          </span>
        )}
      </div>
      <div className="dms-note-info">
        {t("v8_plan_it_note", "Plan-IT Note")}
        {timestamp ? ` ${timestamp}` : null}
      </div>
    </div>
  );
};
